import { ThemeBreakpoints } from '@dev/ee-components';
import { useEffect, useState } from 'react';

export const useCustomIsMobile = (customMobileBreakpoint = ThemeBreakpoints.container /*1170px */) => {
    const [isMobile, setIsMobile] = useState(window.innerWidth < customMobileBreakpoint);

    useEffect(() => {
        const changeIsMobile = () => {
            const shouldBeMobile = window.innerWidth <= customMobileBreakpoint;
            setIsMobile(shouldBeMobile);
        };
        window.addEventListener('resize', changeIsMobile);
        return () => window.removeEventListener('resize', changeIsMobile);
    }, []);
    return isMobile;
};
